const PORTS = [11100, 11101, 11102, 11103, 11104, 11105, 11106];

const xhr = (method, url, body) => new Promise((resolve, reject) => {
  const x = new XMLHttpRequest();
  x.open(method, url, true);
  x.timeout = method === "CAPTURE" ? 25000 : 2500;
  x.setRequestHeader("Content-Type", "text/xml; charset=utf-8");
  x.onload = () => resolve(x.responseText);
  x.onerror = () => reject(new Error("RD service not reachable"));
  x.ontimeout = () => reject(new Error("RD service timeout"));
  x.send(body || null);
});

const findDevice = async () => {
  for (const port of PORTS) {
    try {
      const txt = await xhr("RDSERVICE", `http://127.0.0.1:${port}`);
      const doc = new DOMParser().parseFromString(txt, "text/xml");
      const rd = doc.querySelector("RDService");
      if (!rd) continue;
      const path = [...doc.querySelectorAll("Interface")].find((i) => /capture/i.test(i.getAttribute("id") || ""))?.getAttribute("path") || "/rd/capture";
      if ((rd.getAttribute("status") || "").toUpperCase() === "READY") return `http://127.0.0.1:${port}${path}`;
      throw new Error(`Fingerprint device is ${rd.getAttribute("status") || "not ready"}. Connect the device and try again`);
    } catch (e) { if (/device is/.test(e.message)) throw e; }
  }
  throw new Error("Fingerprint device not found. Install the RD service and connect the device (works on Windows PC browser)");
};

export const captureFinger = async (wadh = "") => {
  const url = await findDevice();
  const opts = `<?xml version="1.0"?><PidOptions ver="1.0"><Opts fCount="1" fType="2" iCount="0" pCount="0" format="0" pidVer="2.0" timeout="15000" posh="UNKNOWN" env="P"${wadh ? ` wadh="${wadh}"` : ""} /><CustOpts></CustOpts></PidOptions>`;
  const txt = await xhr("CAPTURE", url, opts);
  const doc = new DOMParser().parseFromString(txt, "text/xml");
  const resp = doc.querySelector("Resp");
  if (!resp || resp.getAttribute("errCode") !== "0") throw new Error(resp?.getAttribute("errInfo") || "Fingerprint capture failed. Try again");
  const dev = doc.querySelector("DeviceInfo");
  const skey = doc.querySelector("Skey");
  const srno = [...doc.querySelectorAll("Param")].find((p) => /srno|serial/i.test(p.getAttribute("name") || ""));
  return {
    pidData: doc.querySelector("Data")?.textContent || "", hmac: doc.querySelector("Hmac")?.textContent || "",
    Skey: skey?.textContent || "", ci: skey?.getAttribute("ci") || "", ts: resp.getAttribute("ts") || "",
    dc: dev?.getAttribute("dc") || "", mi: dev?.getAttribute("mi") || "", dpId: dev?.getAttribute("dpId") || "",
    mc: dev?.getAttribute("mc") || "", rdsId: dev?.getAttribute("rdsId") || "", rdsVer: dev?.getAttribute("rdsVer") || "",
    srno: srno?.getAttribute("value") || "",
  };
};

export const getGeo = () => new Promise((resolve, reject) => {
  if (!navigator.geolocation) return reject(new Error("Location not supported on this device"));
  navigator.geolocation.getCurrentPosition((p) => resolve({ latitude: p.coords.latitude.toFixed(4), longitude: p.coords.longitude.toFixed(4) }),
    () => reject(new Error("Please allow location access to continue")), { timeout: 10000 });
});
